module.exports = __webpack_public_path__ + "img/api-error.0130577a.png";